import { useState } from "react";
import { Cookie, Settings2, X } from "lucide-react";
import { useCookieConsent } from "@/hooks/useCookieConsent";
import { Switch } from "@/components/ui/switch";
import { Link } from "react-router-dom";

export function CookieConsent() {
  const { open, setOpen, save } = useCookieConsent();
  const [showPrefs, setShowPrefs] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [functional, setFunctional] = useState(true);

  if (!open) return null;

  const acceptAll = () => save({ analytics: true, functional: true });
  const rejectAll = () => save({ analytics: false, functional: false });
  const savePrefs = () => save({ analytics, functional });

  return (
    <div className="fixed inset-x-0 bottom-0 z-[100] p-3 md:p-6 pointer-events-none">
      <div className="pointer-events-auto max-w-4xl mx-auto bg-card/95 backdrop-blur-md border border-border rounded-2xl shadow-2xl p-5 md:p-6">
        <div className="flex items-start gap-3 md:gap-4">
          <div className="hidden sm:flex w-10 h-10 rounded-full bg-primary/20 items-center justify-center flex-shrink-0">
            <Cookie className="w-5 h-5 text-primary" />
          </div>

          <div className="flex-1 min-w-0">
            {!showPrefs ? (
              <>
                <h3 className="text-foreground font-semibold mb-1">Sua privacidade importa</h3>
                <p className="text-sm text-muted-foreground mb-4">
                  Usamos cookies essenciais para o funcionamento da plataforma. Cookies de análise
                  (anônimos) só serão ativados se você consentir. Saiba mais na nossa{" "}
                  <Link to="/privacidade" className="text-primary hover:underline">
                    Política de Privacidade
                  </Link>
                  .
                </p>
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 sm:flex-wrap">
                  <button
                    onClick={acceptAll}
                    className="px-5 py-2.5 rounded-full bg-primary text-primary-foreground font-medium hover:opacity-90 transition-colors text-sm"
                  >
                    Aceitar todos
                  </button>
                  <button
                    onClick={rejectAll}
                    className="px-5 py-2.5 rounded-full bg-secondary text-foreground font-medium hover:bg-secondary/80 transition-colors text-sm"
                  >
                    Rejeitar não essenciais
                  </button>
                  <button
                    onClick={() => setShowPrefs(true)}
                    className="px-5 py-2.5 rounded-full border border-border text-foreground font-medium hover:bg-muted transition-colors text-sm inline-flex items-center justify-center gap-2"
                  >
                    <Settings2 className="w-4 h-4" />
                    Personalizar
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-foreground font-semibold">Preferências de cookies</h3>
                  <button
                    onClick={() => setShowPrefs(false)}
                    className="text-muted-foreground hover:text-foreground transition-colors"
                    aria-label="Fechar"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>
                <div className="space-y-3 mb-4">
                  <div className="flex items-start justify-between gap-3 p-3 rounded-lg bg-muted/40">
                    <div className="min-w-0">
                      <p className="text-sm font-medium text-foreground">Essenciais</p>
                      <p className="text-xs text-muted-foreground">
                        Necessários para login, segurança e funcionamento básico. Não podem ser desativados.
                      </p>
                    </div>
                    <Switch checked disabled />
                  </div>
                  <div className="flex items-start justify-between gap-3 p-3 rounded-lg bg-muted/40">
                    <div className="min-w-0">
                      <p className="text-sm font-medium text-foreground">Funcionais</p>
                      <p className="text-xs text-muted-foreground">
                        Lembram suas preferências (tema, idioma, layout).
                      </p>
                    </div>
                    <Switch checked={functional} onCheckedChange={setFunctional} />
                  </div>
                  <div className="flex items-start justify-between gap-3 p-3 rounded-lg bg-muted/40">
                    <div className="min-w-0">
                      <p className="text-sm font-medium text-foreground">Análise (anônima)</p>
                      <p className="text-xs text-muted-foreground">
                        Métricas agregadas de uso (Google Analytics) para melhorarmos a experiência.
                      </p>
                    </div>
                    <Switch checked={analytics} onCheckedChange={setAnalytics} />
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-2">
                  <button
                    onClick={savePrefs}
                    className="px-5 py-2.5 rounded-full bg-primary text-primary-foreground font-medium hover:opacity-90 transition-colors text-sm"
                  >
                    Salvar preferências
                  </button>
                  <button
                    onClick={() => setOpen(false)}
                    className="px-5 py-2.5 rounded-full border border-border text-foreground font-medium hover:bg-muted transition-colors text-sm"
                  >
                    Cancelar
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}